(() => {
  const money = (root, value) => new Intl.NumberFormat(document.documentElement.lang || 'it-IT', {
    style: 'currency', currency: root.dataset.currency || 'EUR'
  }).format(Number(value || 0));
  const request = async (root, url, options = {}) => {
    const response = await fetch(url, { headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, ...options });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.error || root.dataset.errorLabel);
    return data;
  };

  document.querySelectorAll('[data-quick-catalog]').forEach(root => {
    const rows = root.querySelector('[data-catalog-rows]');
    const search = root.querySelector('[data-catalog-search]');
    const count = root.querySelector('[data-catalog-count]');
    const status = root.querySelector('[data-catalog-status]');
    const cart = root.querySelector('[data-catalog-cart]');
    const save = root.querySelector('[data-catalog-save]');
    const tableWrap = root.querySelector('.besmart-quick-catalog__table-wrap');
    const selected = new Map();
    const cursors = [null];
    let page = 0;
    let nextCursor = null;
    let items = [];
    let activeDraft = null;

    const createPager = () => {
      const container = document.createElement('div');
      const previous = document.createElement('button');
      const following = document.createElement('button');
      const label = document.createElement('span');
      container.className = 'besmart-quick-catalog__pagination';
      previous.type = following.type = 'button';
      previous.className = following.className = 'btn';
      previous.textContent = '← Precedente';
      following.textContent = 'Successiva →';
      container.append(previous, label, following);
      return { container, previous, following, label };
    };

    const topPager = createPager();
    const bottomPager = createPager();
    const pagers = [topPager, bottomPager];
    tableWrap.before(topPager.container);
    tableWrap.after(bottomPager.container);

    const selectedOption = row => row._item.options[row.querySelector('select').value];
    const multiplier = row => Math.max(1, Number(selectedOption(row).multiplier) || 1);
    const normalizePieces = row => {
      const input = row.querySelector('input');
      const amount = multiplier(row);
      const requested = Number.parseInt(input.value, 10) || amount;
      const pieces = Math.max(amount, Math.ceil(requested / amount) * amount);
      input.min = String(amount);
      input.step = String(amount);
      input.value = String(pieces);
      return pieces;
    };
    const sync = () => {
      const enabled = selected.size > 0;
      cart.disabled = !enabled;
      save.disabled = !enabled;
    };
    const optionIds = item => Object.values(item.options || {}).map(option => String(option.variantId));
    const selectedFor = item => optionIds(item).map(id => selected.get(id)).find(Boolean);
    const removeSelectionsFor = item => optionIds(item).forEach(id => selected.delete(id));
    const lineFrom = row => {
      const option = selectedOption(row);
      const pieces = normalizePieces(row);
      const units = pieces / multiplier(row);
      return {
        id: String(option.variantId),
        quantity: option.quantityMode === 'bundle' ? units : pieces,
        properties: {
          Confezionamento: row.querySelector('select').selectedOptions[0].textContent,
          [root.dataset.piecesPerPackLabel]: String(multiplier(row)),
          [root.dataset.requestedPiecesLabel]: String(pieces)
        }
      };
    };
    const paintPrice = row => {
      const option = selectedOption(row);
      const amount = multiplier(row);
      const unit = Number(option.price || 0) || Number(option.bundlePrice) / amount;
      const list = Number(option.listPrice || option.bundlePrice) / amount;
      const discount = list > unit ? Math.round((1 - unit / list) * 100) : 0;
      row.querySelector('[data-catalog-price]').innerHTML = money(root, unit) + '<small>' + root.querySelector('[data-catalog-unit-suffix]').textContent + ' ' + root.dataset.vatLabel + (discount ? ' · ' + root.dataset.discountLabel + ' ' + discount + '%' : '') + '</small>';
    };
    const updatePagers = () => pagers.forEach(pager => {
      pager.label.textContent = root.dataset.pageLabel + ' ' + (page + 1);
      pager.previous.disabled = page === 0;
      pager.following.disabled = !nextCursor;
    });
    const refreshRow = row => {
      normalizePieces(row);
      paintPrice(row);
    };
    const changeQuantity = (row, direction) => {
      const input = row.querySelector('.besmart-quick-catalog__quantity');
      const amount = multiplier(row);
      const current = normalizePieces(row);
      input.value = String(Math.max(amount, current + direction * amount));
      refreshRow(row);
    };
    const render = () => {
      const term = search.value.trim().toLocaleLowerCase();
      const visible = items.filter(item => [item.sku, item.title, item.options.pack?.barcode, item.options.carton?.barcode].filter(Boolean).some(value => String(value).toLocaleLowerCase().includes(term)));
      count.textContent = visible.length + ' ' + root.dataset.productsLabel;
      rows.replaceChildren();
      if (!visible.length) {
        rows.innerHTML = '<tr><td colspan="7">' + root.dataset.emptyLabel + '</td></tr>';
        updatePagers();
        return;
      }
      visible.forEach(item => {
        const choices = [['pack', root.dataset.packLabel], ['carton', root.dataset.cartonLabel]].filter(([key]) => item.options[key]);
        const row = document.createElement('tr');
        row._item = item;
        row.innerHTML = '<td>' + (item.image ? '<img class="besmart-quick-catalog__image" src="' + item.image + '" alt="">' : '') + '</td><td class="besmart-quick-catalog__sku">' + (item.sku || '—') + '</td><td class="besmart-quick-catalog__product"></td><td class="besmart-quick-catalog__price" data-catalog-price></td><td><select class="besmart-quick-catalog__select">' + choices.map(([key, label]) => '<option value="' + key + '">' + label + '</option>').join('') + '</select></td><td><div class="besmart-quick-catalog__quantity-control"><button type="button" class="besmart-quick-catalog__quantity-button" data-catalog-quantity-decrease aria-label="' + root.dataset.decreaseQuantityLabel + '">−</button><input class="besmart-quick-catalog__quantity" type="number" inputmode="numeric" value="1"><button type="button" class="besmart-quick-catalog__quantity-button" data-catalog-quantity-increase aria-label="' + root.dataset.increaseQuantityLabel + '">+</button></div></td><td class="besmart-quick-catalog__row-action"><button type="button" class="btn" data-catalog-confirm>' + root.dataset.confirmLabel + '</button><button type="button" class="btn" data-catalog-remove hidden>' + root.dataset.removeLabel + '</button></td>';
        row.querySelector('.besmart-quick-catalog__product').textContent = item.title;
        const button = row.querySelector('[data-catalog-confirm]');
        const removeButton = row.querySelector('[data-catalog-remove]');
        const paintSelection = () => {
          const selectedLine = selectedFor(item);
          const isSelected = Boolean(selectedLine);
          row.classList.toggle('besmart-quick-catalog__row--confirmed', isSelected);
          button.textContent = isSelected ? root.dataset.updateLabel : root.dataset.confirmLabel;
          removeButton.hidden = !isSelected;
        };
        const selectedLine = selectedFor(item);
        if (selectedLine) {
          const selectedOption = Object.entries(item.options).find(([, option]) => String(option.variantId) === String(selectedLine.id));
          if (selectedOption) row.querySelector('select').value = selectedOption[0];
          const requestedPieces = Number(selectedLine.properties?.[root.dataset.requestedPiecesLabel]);
          if (requestedPieces > 0) row.querySelector('input').value = String(requestedPieces);
        }
        row.querySelector('select').addEventListener('change', () => {
          row.querySelector('input').value = String(multiplier(row));
          refreshRow(row);
        });
        row.querySelector('input').addEventListener('change', () => refreshRow(row));
        row.querySelector('[data-catalog-quantity-decrease]').addEventListener('click', () => changeQuantity(row, -1));
        row.querySelector('[data-catalog-quantity-increase]').addEventListener('click', () => changeQuantity(row, 1));
        button.addEventListener('click', () => {
          refreshRow(row);
          removeSelectionsFor(item);
          const line = lineFrom(row);
          selected.set(String(line.id), line);
          paintSelection();
          sync();
        });
        removeButton.addEventListener('click', () => {
          removeSelectionsFor(item);
          paintSelection();
          sync();
        });
        refreshRow(row);
        paintSelection();
        rows.append(row);
      });
      updatePagers();
    };
    const load = async index => {
      status.textContent = root.dataset.loadingLabel;
      try {
        const cursor = cursors[index];
        const data = await request(root, root.dataset.catalogEndpoint + (cursor ? '?cursor=' + encodeURIComponent(cursor) : ''));
        items = data.items || [];
        nextCursor = data.nextCursor || null;
        page = index;
        if (nextCursor) cursors[index + 1] = nextCursor;
        render();
        status.textContent = '';
      } catch (error) {
        status.textContent = error.message || root.dataset.errorLabel;
      }
    };
    pagers.forEach(pager => {
      pager.previous.addEventListener('click', () => load(page - 1));
      pager.following.addEventListener('click', () => load(page + 1));
    });
    search.addEventListener('input', render);
    window.addEventListener('besmart:edit-draft', event => {
      const draft = event.detail?.draft;
      if (!draft?.id || !Array.isArray(draft.lines)) return;
      selected.clear();
      draft.lines.forEach(line => selected.set(String(line.id), line));
      activeDraft = { id: draft.id, title: draft.title || root.dataset.draftTitle };
      status.textContent = root.dataset.editDraftMessage.replace('{title}', activeDraft.title);
      render();
      sync();
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    cart.addEventListener('click', async () => {
      if (!selected.size) return;
      cart.disabled = true;
      try {
        await request(root, (window.Shopify?.routes?.root || '/') + 'cart/add.js', { method: 'POST', body: JSON.stringify({ items: Array.from(selected.values()) }) });
        window.location.assign((window.Shopify?.routes?.root || '/') + 'cart');
      } catch (error) {
        status.textContent = error.message || root.dataset.errorLabel;
        sync();
      }
    });
    save.addEventListener('click', async () => {
      if (!selected.size) return;
      try {
        const saved = await request(root, root.dataset.draftsEndpoint, {
          method: 'POST',
          body: JSON.stringify({
            action: 'save',
            id: activeDraft?.id,
            title: activeDraft?.title || root.dataset.draftTitle + ' ' + new Date().toLocaleDateString(),
            source: 'catalog',
            lines: Array.from(selected.values())
          })
        });
        activeDraft = { id: saved.id, title: activeDraft?.title || root.dataset.draftTitle + ' ' + new Date().toLocaleDateString() };
        status.textContent = root.dataset.saveSuccess;
        window.dispatchEvent(new CustomEvent('besmart:drafts-changed'));
        root.querySelector('[data-catalog-drafts]')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (error) {
        status.textContent = error.message || root.dataset.errorLabel;
      }
    });
    load(0);
  });
})();
